"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Import = void 0;
const ctx_1 = require("../../ctx");
const env_1 = require("../../env");
const Errors = __importStar(require("../../errors"));
const stmt_1 = require("../../stmt");
const import_1 = require("../import");
class Import extends stmt_1.Stmt {
    constructor(bindings, path, span) {
        super();
        this.bindings = bindings;
        this.path = path;
        this.span = span;
    }
    execute(mod) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = mod.resolve(this.path);
            if (url.href === mod.options.url.href) {
                throw new Errors.ElaborationError(`I can not circular import: ${this.path}`, {
                    span: this.span,
                });
            }
            const importedMod = yield mod.options.loader.load(url);
            for (const binding of this.bindings) {
                const type = (0, ctx_1.ctxLookupType)(importedMod.ctx, binding.name);
                const value = (0, env_1.envLookupValue)(importedMod.env, binding.name);
                if (type === undefined || value === undefined) {
                    throw new Errors.ElaborationError(`I meet undefined name: ${binding.name}, when importing module: ${this.path}`, {
                        span: this.span,
                    });
                }
                (0, import_1.defineBinding)(mod, binding, type, value);
            }
            mod.imported.push(url);
        });
    }
    undo(mod) {
        for (const binding of this.bindings) {
            (0, import_1.undoBinding)(mod, binding);
        }
    }
}
exports.Import = Import;
//# sourceMappingURL=Import.js.map